// extracted by mini-css-extract-plugin
export default {"EmptyCart":"EmptyCart_EmptyCart__GR1iL"};